module.exports = __webpack_public_path__ + "default-author-image-65aeccf65e75d544d490.svg";